var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.297,
    height: 17.479,
    viewBox: "0 0 26.297 17.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(-93.553 -8.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M143.041,15.416c-3.477-2.341-4.6-3.994-4.6-4.428h-2.35V28.467h2.35c0-.434,1.125-2.087,4.6-4.428,2.916-1.963,5.62-3.137,6.549-3.137v-2.35c-.929,0-3.633-1.174-6.549-3.137",
    transform: "translate(-29.74 -2.401)",
    fill: "#001233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M126.667,15.416c-3.477-2.341-4.6-3.994-4.6-4.428h-2.35V28.467h2.35c0-.434,1.125-2.087,4.6-4.428,2.916-1.963,5.62-3.137,6.549-3.137v-2.35c-.929,0-3.633-1.174-6.549-3.137",
    transform: "translate(-26.162 -2.401)",
    fill: "#001233"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.647acd33b4924f89b2338d1aaf5874a2.svg";
export { ForwardRef as ReactComponent };